module.exports = __webpack_public_path__ + "img/top-image3.cfc17675.png";